import i18next from "i18next";

//TODO: Delete this file after migrating all modules to Typescript

export const requestErrorHandling = (error, defaultMessage) => {
  let errors = { "": [defaultMessage] };
  
  if (error?.response?.body?.Errors) {
    errors = {Error: error.response.body?.Errors}
  }
  if (error.response && error.response.body?.errors)
    // The request was made and the server responded with a status code that falls out of the range of 2xx
    errors = error.response.body.errors;
  if (error.response && error.response.body?.error) return errors;
  if (error.request)
    // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
    errors = error.request;
  if (error.message)
    // Something happened in setting up the request that triggered an Error
    return errors;

  return errors;
};

export const getResponseErrorMessage = (error, defaultMessage) => {
  let message = defaultMessage;
  if (error?.response?.body?.errors) {
    for (const e in error.response.body.errors) {
      message = [];
      message.push(error.response.body.errors[e]);
    }
  }
  if (error?.response?.body?.error) message = error.response.body.error;
  if (error.request) message = error.request;
  if (error.message) message = error.message;

  return message;
};

export const getErrorMessage = (error, defaultMessage) => {
  let message = defaultMessage;

  if (error.errors) {
    message = [];
    Object.values(error.errors).forEach((e) => {
      if (Array.isArray(e)) {
        
        e.forEach((m) => message.push(i18next.exists(`Errors.${m}`) ? i18next.t(`Errors.${m}`) : m))
      } else {
        message.push(i18next.exists(`Errors.${e}`) ? i18next.t(`Errors.${e}`) : e);
      }
    });
  }

  if (error.Errors) {
    message = [];
    Object.values(error.Errors).forEach((e) => {
      if (Array.isArray(e)) {
        e.forEach((m) => message.push(i18next.exists(`Errors.${m}`) ? i18next.t(`Errors.${m}`) : m))
      } else {
        message.push(i18next.exists(`Errors.${e}`) ? i18next.t(`Errors.${e}`) : e);
      }
    });
  }

  if (error.message) {
    message = error.message + ' ';
  }

  if (error.Messages) {
    message += error.Messages.map((e) => (i18next.exists(`Errors.${e}`) ? i18next.t(`Errors.${e}`) : e) + ' ');
  }

  if (error.Exception) {
    message += ` ${i18next.exists(`Errors.${error.Exception}`) ? i18next.t(`Errors.${error.Exception}`) : error.Exception} `
  }

  return message;
};
